import { createClassName } from 'utils/createClassName';

import './tableControlsLayoutStyles.scss';

export const createElementClassName = createClassName('table-controls-layout');
